import { render, staticRenderFns } from "./orderData.vue?vue&type=template&id=55575e69&scoped=true&"
import script from "./orderData.vue?vue&type=script&lang=js&"
export * from "./orderData.vue?vue&type=script&lang=js&"
import style0 from "./orderData.vue?vue&type=style&index=0&id=55575e69&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55575e69",
  null
  
)

export default component.exports